<template>
  <table class="tableDettaglio">
    <tr>
      <th v-for="(header,i) in getHeaders" :key="i">
        <span v-html="header"></span>
      </th>
    </tr>
    <tr v-for="(item,z) in dati" :key="z">
      <td v-for="(header,x) in getHeaders" :style="header.style" :key="x">
        <span v-html="item[header]"></span>
      </td>
    </tr>
  </table>
</template>

<script>
export default {
  props: {
    dati: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },

  methods: {
    formatValue(valore, tipo) {
      if (tipo == "Money") return "€ " + parseFloat(valore).toFixed(2);

      return valore;
    },

    changeSort(item) {
      // Controllo sort attivo
      if (!item.sortable) return;

      if (this.pagination.sortBy === item.value) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = item.value;
        this.pagination.descending = false;
      }
    }
  },

  computed: {
    getHeaders() {
      let h = [];

      this.dati.forEach(value => {
        // Ciclo sulle chiavi del json
        for (var key in value) {
          if (h.indexOf(key) != -1) continue;

          h.push(key);
        }
      });

      return h;
    }
  }
};
</script>


<style scoped>
/* ---------------------- */
/*   Tabella dettaglio    */
/* ---------------------- */
table.tableDettaglio {
  table-layout: fixed;
  /*background-color: whitesmoke;*/
  border-spacing: 0px;
  margin: auto;
  box-shadow: 2px 2px 5px 0px #e0e0e0;
}
table.tableDettaglio th {
  height: 30px !important;
  text-align: left;
  background-color: #e0e0e0;
}

table.tableDettaglio th:first-child,
th:not(:first-child),
td:first-child,
td:not(:first-child) {
  padding: 5px !important;
}

table.tableDettaglio td {
  height: 30px !important;
  color: black;
  border-bottom: 1px solid lightgray;
  border-right: 1px solid #d9d9d9;
}
/* ---------------------- */
</style>
